import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import DrawerLayout from 'components/Views/Creative/Drawers/DrawerLayout';
import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';
import { timestampCompare } from 'utils/FirestoreUtils';

import VideoBundleRow from './VideoBundleRow';

function VideoBundlesDrawer() {
  const store_creative = store.creative;
  const store_creative_videoBundles = store_creative?.videoBundles;

  useEffect(() => {
    if (store_creative_videoBundles && !store_creative_videoBundles.mounted) {
      void store_creative_videoBundles.load();
    }
  }, [store_creative_videoBundles]);

  if (!store_creative || !store_creative_videoBundles) return null;

  const videoBundles = [...store_creative_videoBundles.all];
  videoBundles.sort((a, b) =>
    timestampCompare(a.data.createTime, b.data.createTime)
  );

  const handleOnClose = () => {
    store_creative.setPanel(PanelViews.NONE);
  };

  return (
    <DrawerLayout
      open={store_creative.displayPanel === PanelViews.VIDEO_BUNDLES}
      onClose={handleOnClose}
      title="Video Bundles"
    >
      {videoBundles.map((vb) => (
        <VideoBundleRow key={vb.id} videoBundle={vb} />
      ))}
    </DrawerLayout>
  );
}

export default observer(VideoBundlesDrawer);
